module.exports = __webpack_public_path__ + "img/leprosymission.f33a080.png";